import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';

import {catchError, switchMap} from 'rxjs/operators';
import {Observable, of, Subscription} from 'rxjs';

import { AuthorizationService } from 'src/app/services/authorization/authorization.service';

import {ApplicationConstant} from 'src/app/utilities/ApplicationConstant';
import { SessionService } from '../services';
import { AuthGuard } from './auth-guard';

@Injectable({
    providedIn: 'root'
})
export class RouteGuard implements CanActivate {
    public isAdmin = false;
    private sessionSub: Subscription;
    private adminSub: Subscription;

    constructor(private authGuard: AuthGuard,
                private authzService: AuthorizationService,
                private sessionService: SessionService) {

        this.getIsAdmin();
        // Track admin role when user changes
        this.sessionService.userChanged.subscribe(() => {
            this.getIsAdmin();
        });
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authGuard.canActivate(next, state).pipe(
            switchMap(() => {
                return new Observable<boolean>(obs => {
                    if (this.sessionSub) {
                        this.sessionSub.unsubscribe();
                    }
                });
            }),
            catchError(err => of(false)));
    }

    private getIsAdmin() {
        if (this.adminSub) {
            this.adminSub.unsubscribe();
        }
        this.adminSub = this.authzService.hasAccess([ApplicationConstant.getAdminRole()]).subscribe(isAdmin => {
            this.isAdmin = isAdmin;
        });
    }
}
